export const memberStatus = ({ text = '', tooltip = '', style = '' }) => {
    const result = document.createElement('member-status');
    result.className = 'team-member-status';
    result.classList.add(style);
    result.textContent = text;
    result.title = tooltip;
    return result;
};
